export const ItemStatus = {
  Pending: "Pending",
  Delivered: "Delivered",
  Cancelled: "Cancelled",
};
